import { render, staticRenderFns } from "./DeliveryAddressNewTitle.vue?vue&type=template&id=4f5876be&"
import script from "./DeliveryAddressNewTitle.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressNewTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports